import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import baseUrl from "../../api/baseUrl";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../redux/loader/loaderActions";
import {
  addAditionalNote,
  addDiagnoseNote,
  addDiagnoses,
  addDiagnosesImage,
  addPrescriptions,
  addTreatmentImage,
} from "../../redux/diagnosestate/diagnoseAction";
import Treatments from "./treatmenttable/components/treatments/Treatments";

function PlannedTreatments() {
  const { ID } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [allTeatment, setallTeatment] = useState<any[]>([]);
  const [subTreatOpen, setsubTreatOpen] = useState(false);
  const [treatment_id, settreatment_id] = useState("");

  const fetchData = useCallback(() => {
    if (!ID) return;
    dispatch(setloadeActive());
    baseUrl
      .get("treatment/find-treatment", { headers: { treatmentid: ID } })
      .then((response) => {
        const {
          aditionalNote,
          patientComplain,
          diagnose: diagnoseData,
          imageDiagnose,
          imageTreatment,
          prescription,
        } = response.data.data;

        function cleanDoseArray(data: any) {
          return (data || []).map((item: any) => ({
            _id: item?._id || "",
            dose: item?.doseId || "",
            drugsId: item?.drugsId?._id || "",
            drugs: item?.drugsId?.drugs || "",
            type: item?.drugsId?.type || "",
            duration: item?.duration || "",
            frequency: item?.frequency || "",
            createdAt: item?.createdAt || "",
          }));
        }
        dispatch(addPrescriptions(cleanDoseArray(prescription) ?? []));
        dispatch(addAditionalNote(aditionalNote));
        dispatch(addDiagnoseNote(patientComplain));
        dispatch(addDiagnoses(diagnoseData));
        dispatch(addDiagnosesImage(imageDiagnose));
        dispatch(addTreatmentImage(imageTreatment));
        setallTeatment(response.data.data.treatment || []);
      })
      .catch(console.error)
      .finally(() => dispatch(setloadeDeactive()));
  }, [ID, dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleAddSubTreatmentModal = (e: any) => {
    settreatment_id(e);
    setsubTreatOpen((prev) => !prev);
  };

  const plannedCount = allTeatment?.filter((t: any) => t.status === "planned").length || 0;

  return (
    <div className="space-y-3">
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow border border-slate-200 dark:border-slate-700 overflow-hidden">
        <div className="px-4 py-2.5 border-b border-slate-200 dark:border-slate-700">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-sm font-bold text-slate-800 dark:text-slate-100">Treatment Planned</h3>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{plannedCount} planned treatments</p>
            </div>
          </div>
        </div>
        <div className="p-3 overflow-x-auto">
          <Treatments
            allTeatment={allTeatment?.filter((t: any) => t.status === "planned") || []}
            setallTeatment={setallTeatment}
            handleAddSubTreatmentModal={handleAddSubTreatmentModal}
          />
          {plannedCount === 0 && (
            <div className="py-8 text-center text-slate-400 dark:text-slate-500">
              <p className="text-xs">No planned treatments</p>
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-end">
        <button
          onClick={() => navigate(`/client/payments/invoice/${ID}`)}
          className="px-4 py-2 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-medium text-xs hover:shadow-lg hover:shadow-primary/20 transition-all"
        >
          Go to Pay
        </button>
      </div>
    </div>
  );
}

export default PlannedTreatments;
